import "./DeleteDialog.css";

import { faTrashCan, faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";

const DeleteDialog = ({recordToDelete, dialogActionHandler }) => {

  const [loading ,setLoading] = useState(false);
  const onActionHandler = (actionType) => {
    dialogActionHandler(actionType);
    setLoading(true);
  };

  useEffect(() => {
    return () => setLoading(false);
  },[])

  return (
    <div className="delete-dialog-container">
      <div className="delete-dialog-wrapper">
        <div className="delete-dialog-icon-wrapper">
          <FontAwesomeIcon icon={faTrashCan} className="dialog-warning-icon" />
        </div>
        <h2 className="delete-dialog-title">
          Delete &nbsp;{`${recordToDelete}`} ?
        </h2>
        <span className="delete-dialog-description">
          Are you sure you want to delete this record ? <br />
          This action cannot be undone
        </span>

        <div className="delete-actions">
          <button
            className="btn-action btn-cancel"
            onClick={() => onActionHandler("cancel")}
          >
            No, Keep it.
          </button>
          <button
            className="btn-action btn-delete"
            onClick={() => onActionHandler("delete")}
          >
            {loading && (
              <span>
                <FontAwesomeIcon
                  icon={faCircleNotch}
                  className="loader-icon"
                  onClick={() => setDeleteElement(warehouse)}
                />
              </span>
            )}
            Yes, Delete!
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteDialog;
